import Button from '@mui/material/Button';
import { ReactNode } from 'react';
import { ToggleButtonSurface, useToggleButton } from './ToggleButtonGroup';

export const TOGGLE_BUTTON_FILL = '#0d3c61';

// The selected button paints its own dark fill, so its label is white on either
// surface. The unselected button is transparent, so its label has to follow the
// surface it sits on -- white on the dark quick-filter strip, the fill colour on
// a light form. A single hardcoded white made "Per day" white-on-white and so
// invisible on the resource details form (ADO #94651).
const styleFor = (surface: ToggleButtonSurface) => ({
  padding: '5px',
  '&.MuiButton-root': {
    fontWeight: '700',
    height: '30px',
  },
  '&.MuiButton-contained': {
    backgroundColor: TOGGLE_BUTTON_FILL,
    color: 'white',
  },
  '&.MuiButton-text': {
    color: surface === 'light' ? TOGGLE_BUTTON_FILL : 'white',
  },
});

export const ToggleButton = ({
  value,
  children,
  disabled,
  ...rest
}: {
  value: string;
  disabled?: boolean;
  children: ReactNode;
}) => {
  const { currentValue, setValue, surface } = useToggleButton();

  return (
    <Button
      size="small"
      sx={styleFor(surface)}
      variant={value === currentValue ? 'contained' : 'text'}
      onClick={() => setValue(value)}
      disabled={disabled}
      {...rest}
    >
      {children}
    </Button>
  );
};
